import { ViteReactSSG } from 'vite-react-ssg';
import './styles/global.css';
import { routes } from './routes';
import { installFrontendErrorReporter } from './lib/frontend-error-reporter';

// SSG 배선: createRoot 를 직접 호출하지 않고 ViteReactSSG 로 export 한다.
//   - 빌드: vite-react-ssg 가 이 export 를 가져와 각 라우트를 정적 HTML 로 렌더.
//   - 런타임: 브라우저에서 자동으로 mount(dev: vite) / hydrate(빌드 산출물)된다.
// HelmetProvider 래핑은 vite-react-ssg 내부에서 처리(Phase 3 의 Head 주입용).
export const createRoot = ViteReactSSG({ routes }, ({ isClient }) => {
  if (!isClient) return;
  installFrontendErrorReporter();
  // index.html splash 에 마운트 완료 신호. 다음 paint 이후 발사하여
  // 빈 화면이 잠깐 보이는 것을 방지. 정적 렌더 시엔 실행 금지(isClient 가드).
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new Event('app:ready'));
    });
  });
});
